import * as ApiRequests from '../../api/requests';
import { AuthHelper } from '../../types/auth-helper-types';
import { AppThunk } from '../actions';
import { GetSubscriptionActions } from '../actions/get-subscription-actions';

export const GetSubscriptionThunks = {
    getSubscription: (authHelper: AuthHelper, addToast: Function): AppThunk => async (dispatch): Promise<void> => {
        dispatch(GetSubscriptionActions.getSubscriptionStarted());

        const payload = await ApiRequests.getSubscriptionLink({}, { authHelper });
        if (payload.ok) {
            dispatch(
                GetSubscriptionActions.getSubscriptionSucceeded(
                    payload.response.message,
                    payload.response.data,
                    payload.response.data.subscriptionUrl
                )
            );
        } else {
            const errorCode = ApiRequests.extractResponseNotOkCode(payload.response);
            if (errorCode) {
                addToast(ApiRequests.extractResponseNotOkMessage(payload.response), 'error');
            }
            dispatch(GetSubscriptionActions.getSubscriptionFailed(errorCode.toString()));
        }
    },

    GetPartNumberDetails: (
        GetPartData: {
            siteId: string;
        },
        authHelper: AuthHelper,
        addToast: Function
    ): AppThunk => async (dispatch): Promise<void> => {
        dispatch(GetSubscriptionActions.getPartNumberStarted());

        const payload = await ApiRequests.getPartNumberDetails(
            {
                siteId: GetPartData.siteId,
            },
            { authHelper }
        );

        if (payload.ok) {
            dispatch(
                GetSubscriptionActions.getPartNumberSucceeded(
                    // payload.response.message,
                    payload.response.data
                )
            );
        } else {
            const errorCode = ApiRequests.extractResponseNotOkCode(payload.response);
            if (errorCode) {
                addToast(ApiRequests.extractResponseNotOkMessage(payload.response), 'error');
            }
            dispatch(GetSubscriptionActions.getPartNumberFailed(errorCode.toString()));
        }
    },
    GetSiteSubscriptionDetails: (
        GetSubscriptionData: {
            siteId: string;
        },
        authHelper: AuthHelper,
        addToast: Function
    ): AppThunk => async (dispatch): Promise<void> => {
        dispatch(GetSubscriptionActions.getSiteSubscriptionStarted());

        const payload = await ApiRequests.getSiteSubscriptionDetails(
            {
                siteId: GetSubscriptionData.siteId,
            },
            { authHelper }
        );

        if (payload.ok) {
            dispatch(
                GetSubscriptionActions.getSiteSubscriptionSucceeded(
                    // payload.response.message,
                    payload.response.data
                )
            );
        } else {
            const errorCode = ApiRequests.extractResponseNotOkCode(payload.response);
            if (errorCode) {
                addToast(ApiRequests.extractResponseNotOkMessage(payload.response), 'error');
            }
            dispatch(GetSubscriptionActions.getSiteSubscriptionFailed(errorCode.toString()));
        }
    },

    MapSiteIdActivationId: (
        mappingData: {
            activationId: string;
            address: object;
            siteId: string;
        },
        authHelper: AuthHelper,
        addToast: Function
    ): AppThunk => async (dispatch): Promise<void> => {
        dispatch(GetSubscriptionActions.mappingSiteIdActivationIdStarted());

        const payload = await ApiRequests.mappingSiteIdActivationId(
            {
                activationId: mappingData.activationId,
                address: mappingData.address,
                siteId: mappingData.siteId,
            },
            { authHelper }
        );
        if (payload.ok) {
            dispatch(
                GetSubscriptionActions.mappingSiteIdActivationIdSucceeded(
                    payload.response.message,
                    payload.response.data,
                    payload.response.data.subscriptionType,
                    payload.response.data.quantity,
                    payload.response.data.expirationDate
                )
            );
        } else {
            const errorCode = ApiRequests.extractResponseNotOkCode(payload.response);

            if (errorCode === 10050) {
                const errorDescription =
                    'An identical subscription is already active at this site. Please update the quantity or choose a different type of subscription to make changes to the site current subscription plan.';
                addToast(errorDescription, 'error');
            } else if (errorCode === 9004) {
                addToast('Your Activation ID is invalid. Please contact Eaton support for assistance.', 'error');
            } else if (errorCode === 11009) {
                addToast(
                    'Your Activation ID mapping is not correct. Please do correct mapping as per hierarchy.',
                    'error'
                );
            } else if (errorCode === 9005) {
                addToast(
                    'The Activation ID entered has already been used for another site. Please enter the correct Activation ID or contact Eaton Support for assistance.',
                    'error'
                );
            } else {
                addToast(ApiRequests.extractResponseNotOkMessage(payload.response), 'error');
            }

            dispatch(GetSubscriptionActions.mappingSiteIdActivationIdFailed(errorCode.toString()));
        }
    },

    CreateEntitlement: (
        CreateEntitlementData: {
            emailId: string;
        },
        authHelper: AuthHelper,
        addToast: Function
    ): AppThunk => async (dispatch): Promise<void> => {
        dispatch(GetSubscriptionActions.createEntitlementStarted());

        const payload = await ApiRequests.createEntitlement(
            {
                emailId: CreateEntitlementData.emailId,
            },
            { authHelper }
        );

        if (payload.ok) {
            dispatch(
                GetSubscriptionActions.createEntitlementSucceeded(payload.response.message, payload.response.data)
            );
        } else {
            const errorCode = ApiRequests.extractResponseNotOkCode(payload.response);
            if (errorCode) {
                addToast(ApiRequests.extractResponseNotOkMessage(payload.response), 'error');
            }
            dispatch(GetSubscriptionActions.createEntitlementFailed(errorCode.toString()));
        }
    },
};
